<mojo-viewbar></mojo-viewbar>
<mojo-page-title [showProductTitle]="true" title="Profile to User Assignment"></mojo-page-title>
<mojo-user-profile-table [profiles]="profiles$ | async" [userProfiles]="userProfiles$ | async" [loading]="loading$ | async"></mojo-user-profile-table>

